import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface PrivateLibrarySlice {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
}

const initialState: PrivateLibrarySlice = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
};

export const privateLibrarySlice = createSlice({
  name: 'PrivateLibrary',
  initialState,
  reducers: {
    setPrivateLibrary: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setPrivateLibraryBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPrivateLibrary,setPrivateLibraryBySearch,reset } = privateLibrarySlice.actions;
export const getPrivateLibraryDetails = (state: RootState) => state.privateLibrary.data;
export const getPrivateLibraryBySearchDetails= (state: RootState) => state.privateLibrary.data;
export const getPrivateLibraryTotalRecords=(state:RootState)=>state.privateLibrary.totalRecords;
export default privateLibrarySlice.reducer;